import { Card, Grid } from "@material-ui/core"
import { CardProdutosMotoboyProps } from "./card-produtos-motoboy-props"
import { CardProduto } from "./components/card-produto/card-produto"
import { useStyles } from "./card-produtos-motoboy-styles"
import { PedidoProdutoModel } from "../../../../model/api/pedidos/pedido-produto-model"
import { EnumTpProduto } from "../../../../model/enums/enum-tp-produto"

export const CardProdutosMotoboy = ({ produtos, ...props }: CardProdutosMotoboyProps) => {
    const classes = useStyles();

    const produtosAdicionais =
        produtos.filter((produto) => (produto.tpProduto.codigo === EnumTpProduto.Adicional || produto.tpProduto.codigo === EnumTpProduto.Insumo || produto.tpProduto.codigo === EnumTpProduto.Opcional)) ?? [];

    const agruparProdutosSubItens = () => {
        const produtosAgrupados: PedidoProdutoModel[] =
            produtos.filter((p) => !p.produtoPai && (p.tpProduto.codigo === EnumTpProduto.ProdutoComSubItem || p.tpProduto.codigo === EnumTpProduto.Produto || p.tpProduto.codigo === EnumTpProduto.Combo || p.tpProduto.codigo === EnumTpProduto.Medicamento));

        return produtosAgrupados.map((prodAgrupado) => {
            const prodAdicional = produtosAdicionais.filter(
                (adicional) => adicional.groupId === prodAgrupado.codigoReferencia && adicional.tpProduto.codigo !== EnumTpProduto.Combo && adicional.tpProduto.codigo !== EnumTpProduto.ProdutoComSubItem && adicional.tpProduto.codigo !== EnumTpProduto.Produto && adicional.tpProduto.codigo !== EnumTpProduto.Medicamento
            );

            if (prodAdicional.length > 0) {
                return {
                    ...prodAgrupado,
                    adicionais: prodAdicional
                };
            }

            return {
                ...prodAgrupado,
                adicionais: []
            };
        });
    };


    const produtosList = agruparProdutosSubItens();

    function ehUltimoElemento<T>(array: T[], elemento: T): boolean {
        const ultimoIndice = array.length - 1;
        const indiceDoElemento = array.indexOf(elemento);

        return indiceDoElemento === ultimoIndice;
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} className={classes.cardProduto}>
                <Card
                    style={{
                        boxShadow: '1px 1px 1px 2px rgb(0, 0, 0, 0.1)',
                        padding: '8px',
                    }}
                >
                    {produtosList.map((item) => {
                        const ultimoIndex = ehUltimoElemento(produtosList, item)
                        return (
                            <CardProduto
                                model={item}
                                ultimoIndex={ultimoIndex}
                            />
                        )
                    })}
                </Card>
            </Grid>
        </Grid>
    )
}